module.exports = __webpack_public_path__ + "media/images/paypal-partner-88300f9b.svg";